(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('CountryPhoneCode', CountryPhoneCode);

    CountryPhoneCode.$inject = ['$resource'];

    function CountryPhoneCode ($resource) {
        var resourceUrl =  'api/country-phone-codes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
